import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import Dashboard from './Dashboard';
import ProtectedRoute from './ProtectedRoute';
import Po from './Po';
import InputPo from './InputPo';
import Do from './Do';
import InputDo from './InputDo';
import Ts from './Ts';
import InputTs from './InputTs';
import Ppo from './Ppo';
import InputPpo from './InputPpo';
import Mobilfree from './Mobilfree';
import InputMobilfree from './InputMobilfree';
import LapHk from './LapHk';
import LapSJ from './LapSJ';
import LapMG from './LapMG';
import LapJBM from './LapJBM';
import LastPosition from './LastPosition';
import LapDaily from './LapDaily';
import LapMastergaji from './LapMastergaji';
import LapKM from './LapKM';
import LapKinerja from './LapKinerja';
import MasterInvoice from './MasterInvoice';
import Bk from './Bk';
import InputBk from './InputBk';
import Hk from './Hk';
import InputHk from './InputHk';

function App() {
  return (
    <Router basename="/ptkmt">
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        
        <Route path="/login" element={<LoginPage />} />

        <Route 
          path="/dashboard" 
          element={<ProtectedRoute>  <Dashboard />  </ProtectedRoute> } 
        /> 

        <Route 
          path="/Po" 
          element={<ProtectedRoute> <Po /> </ProtectedRoute> } 
        />   

        <Route 
          path="/InputPo" 
          element={<ProtectedRoute> <InputPo /> </ProtectedRoute> } 
        />      

        <Route 
          path="/Do" 
          element={<ProtectedRoute> <Do /> </ProtectedRoute> } 
        />        

        <Route 
          path="/InputDo" 
          element={ <ProtectedRoute> <InputDo /> </ProtectedRoute> } 
        />            

        <Route 
          path="/Ts" 
          element={<ProtectedRoute> <Ts /> </ProtectedRoute> } 
        />   

        <Route 
          path="/InputTs" 
          element={<ProtectedRoute> <InputTs /> </ProtectedRoute> } 
        />                         

        <Route 
          path="/Mobilfree" 
          element={<ProtectedRoute> <Mobilfree /> </ProtectedRoute> } 
        />   

        <Route 
          path="/InputMobilfree" 
          element={<ProtectedRoute> <InputMobilfree /> </ProtectedRoute> } 
        />     

        <Route 
          path="/Bk" 
          element={<ProtectedRoute> <Bk /> </ProtectedRoute> } 
        />   

        <Route 
          path="/InputBk" 
          element={<ProtectedRoute> <InputBk /> </ProtectedRoute> } 
        />            

        <Route 
          path="/Hk" 
          element={<ProtectedRoute> <Hk /> </ProtectedRoute> } 
        />   

        <Route 
          path="/InputHk" 
          element={<ProtectedRoute> <InputHk /> </ProtectedRoute> } 
        />      

        <Route 
          path="/Ppo" 
          element={<ProtectedRoute> <Ppo /> </ProtectedRoute> } 
        />   

        <Route 
          path="/InputPpo" 
          element={<ProtectedRoute> <InputPpo /> </ProtectedRoute> } 
        />    

        <Route 
          path="/LapHk" 
          element={<ProtectedRoute> <LapHk /> </ProtectedRoute> } 
        />

        <Route 
          path="/LapSJ" 
          element={<ProtectedRoute> <LapSJ /> </ProtectedRoute> } 
        />

        <Route 
          path="/LapMG" 
          element={<ProtectedRoute> <LapMG /> </ProtectedRoute> } 
        />


        <Route 
          path="/LapJBM" 
          element={<ProtectedRoute> <LapJBM /> </ProtectedRoute> } 
        />

        <Route 
          path="/LapKM" 
          element={<ProtectedRoute> <LapKM /> </ProtectedRoute> } 
        />        

        <Route 
          path="/LapKinerja" 
          element={<ProtectedRoute> <LapKinerja /> </ProtectedRoute> } 
        />       

        <Route 
          path="/LastPosition" 
          element={<ProtectedRoute> <LastPosition /> </ProtectedRoute> } 
        />

        <Route 
          path="/LapDaily" 
          element={<ProtectedRoute> <LapDaily /> </ProtectedRoute> } 
        />

        <Route 
          path="/LapMastergaji" 
          element={<ProtectedRoute> <LapMastergaji /> </ProtectedRoute> } 
        />

        <Route 
          path="/MasterInvoice" 
          element={<ProtectedRoute> <MasterInvoice /> </ProtectedRoute> } 
        />

      </Routes>
    </Router>
  );
}

export default App;
